  <template>
<div>
    <Alert v-bind:message='message' type="alert-success" v-if="message" />
    <Alert v-bind:message='error' type="alert-danger" v-if="error" />
    <div class="row">
      <div class="col-12">
        <h2 class="">Dashboard</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="container">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item">
                <a
                class="nav-link active"
                id="pills-home-tab"
                data-toggle="pill"
                href="#pills-home"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
                >Create entity Admin</a>
            </li>
            <li class="nav-item">
                <a
                class="nav-link"
                id="pills-profile-tab"
                data-toggle="pill"
                href="#pills-profile"
                role="tab"
                aria-controls="pills-profile"
                aria-selected="false"
                >View created entity admins</a>
            </li>
            </ul>
        </div>
        <!-- end of pill links -->
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <div class="container">
              <div class="row">
                <div class="col-sm-12 col-xs-12 col-md-9 col-lg-10">
                  <div class="card border-left-danger py-5">
                    <div class="card-body">
                      
                      <form class="" @submit.prevent="createGlobalAdmin">
                            <div class="form-group mb-2">
                                <label for="name" class="form-label">Name</label>
                                <input type="text" class="form-control" id="name" placeholder="eg, kwaku" v-model="name" required>
                            </div>
                            <div class="form-group mb-2">
                                <label for="email" class="form-label">Email</label>
                                <input type="email" class="form-control" id="email" placeholder="me@example.com" v-model="email" required>
                            </div>  
                            <div class="form-group">
                              <label for="exampleFormControlSelect1">Role</label>
                              <select class="form-control" id="exampleFormControlSelect1" v-model="role">
                                <option disabled  value="">Select role</option> 
                                <option>Market Admin</option>
                                <option>Global Admin</option>
                                <option>Entity Admin</option>
                              </select>
                            </div>
                            <button type="submit" class="btn btn-outline-danger my-2 btn-lg">
                              Create 
                                <RoundSpinner v-if="loading" />
                              </button>
                        </form>  
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> 
          <!-- end of create globaladmin -->
          <div
            class="tab-pane fade"
            id="pills-profile"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
            >
              <div class="contaner">
                <div class="row">
                    <div class="col">
                    <div class="card border-left-danger">
                        <div class="card-body">
                        <div class="row" >
                            <div class="col">
                            <p class="my-5 text-center"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                            <div class="card">
                                <div class="card-body">
                                <div class="table-responsive">
                                    <table
                                    class="table table-bordered"
                                    id="dataTable"
                                    width="100%"
                                    cellspacing="0"
                                    >
                                    <thead>
                                        <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Role</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Role</th>
                                        </tr>
                                    </tfoot>
                                    </table>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div>
  </div>

</div>
</template>     
<script>
import Alert from '@/components/Alert'
import RoundSpinner from '@/components/RoundSpinner'
// import Table from '../admin/Table'

export default {
    name:'MarketAdmin',
    components: {
        Alert:Alert,
        RoundSpinner:RoundSpinner,
        // Table:Table
    },
    data(){
        return {
            name:'',
            email:'',
            role:'',
            message:null,
            error:null,
            loading:false,
            marketName:null,
            success:null,
            addError:null
        }
    }
    ,
    methods:{
        createGlobalAdmin(){
          this.loading = true
            const data = {  
                name:this.name,
                email:this.email,
                role:this.role,
            }

            this.$store.dispatch('createGlobalAdmin', data)
                .then(response => {
                  console.log('response', response)
                    this.loading = false
                    this.message =  'Entity Admin created successfully'
                    this.role = ''
                    this.email = ''
                    this.name = ' '
                }).catch(err => {
                    if(err) {
                      this.loading = false
                      this.error = err.response.data.message
                    }
                })
        }
    },
    computed: {
    },
    created() { 
    } 
    
}
</script>
<style scoped>
.nav-link{
    color: #ba2428;
}
a#pills-profile-tab.nav-link.active,a#pills-home-tab.nav-link.active{
    background-color:#ba2428;
    color:#fff;
}
</style>